





































































import Vue from 'vue'
import { mapGetters } from 'vuex'

/* eslint-disable */ 
import { Order } from '@/models/Order'
import { OrderItem } from '@/models/OrderItem'
/* eslint-enable */ 

export default Vue.extend({

  data() {
    return {
      snackbar: false,
      snackbarText: '',
      editedOrder: {} as Order,
      loading: false as boolean,
      headers: [
        {
          text: 'Date',
          sortable: false,
          align: 'start',
          value: 'updatedAt'
        },
        {
          text: 'Total Price',
          sortable: false,
          value: 'total'
        }
      ],
      orderHeaders: [
        {
          text: 'Product Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Number',
          sortable: false,
          value: 'number'
        },
        {
          text: 'Price',
          sortable: false,
          value: 'price'
        },
        {
          text: 'Quantity',
          sortable: false,
          value: 'quantity'
        },
        {
          text: 'Options Charges',
          sortable: false,
          value: 'optionPrice'
        },
        {
          text: 'Item Total',
          sortable: false,
          value: 'total'
        }
      ],
    }
  },
  props: ['selectedOrder'],
  computed: {
    ...mapGetters({
      dealerId: 'dealers/currentDealerId',
      currentDealer: 'dealers/currentDealer'
    }),
    obs () : any {
      return this.$refs.observer as any
    },
    subtotal() : number {
      let subtotal = 0
      this.editedOrder.orderItems.forEach((item : OrderItem) => {
          subtotal += this.getItemTotal(item)
      })

      return subtotal
    },
    tax() : number {
      return this.subtotal * (this.currentDealer.hst / 100)
    },
    total() : number {
      return this.subtotal + this.tax
    }
  },
  methods: {
    async updateOrder() {
      const isValid = await this.obs.validate()
      if (isValid) {
        this.patchOrder()
      } else {
        this.$vuetify.goTo(".error--text")
      }
    },
    patchOrder() {
      this.loading = true
      this.editedOrder.orderItems.forEach((item: OrderItem) => {
        item.total = this.getItemTotal(item)
      })

      this.editedOrder.subtotal = this.subtotal
      this.editedOrder.tax = this.tax
      this.editedOrder.total = this.total
      Order.updateOrder(this.editedOrder)
      this.loading = false
      this.$emit('closeDialog')
    },
    cancel() {
      this.$emit('closeDialog')
    },
    getItemTotal(item: OrderItem) {
      return item.installed ? (item.installedPrice + item.optionPrice) * item.quantity : (item.price + item.optionPrice) * item.quantity
    }
  },
  created() {
    this.editedOrder = Object.assign({}, this.selectedOrder)
  }
})
